enum LifeCycleStage {
  "Visualise",
  "Select",
  "Define",
  "Execute",
}

export default LifeCycleStage;
